import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as Actions from 'auth/store/actions/index';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles/index';
import { AppBar, Button, Card, CardContent, Divider, Typography, Grid, Paper } from '@material-ui/core';
import classNames from 'classnames';
import { TextFieldFormsy, FuseAnimate } from '@fuse';
import Formsy from 'formsy-react';


const styles = theme => ({
    root: {
        backgroundImage: "url(assets/images/backgrounds/header-bg.png)",
        backgroundSize: 'auto',
        height: '100vh'
    },
    intro: {
        color: '#ffffff'
    },
    cardDiv: {
        height: '60%'
    },
    paddingDiv: {
        paddingTop: '10vh'
    },
    instructionsDiv: {
        padding: '15px',
        fontSize: '18px',
    },
    sendButton: {
        paddingLeft: '15px',
        paddingRight: '15px',
        paddingBottom: '15px'
    },
    textField: {
        paddingLeft: '15px',
        paddingRight: '15px',
        width: '100%'
    },
    sendNotice: {
        paddingTop: '5px'
    }
});


class PasswordResetEmailRequest extends Component {

    state = {
        emailSent: false
    }

    onSubmit = (model) => {
        this.props.getUserByEmail(model.email)
        this.setState({
            emailSent: true
        })
    }

    render() {
        const { classes } = this.props

        return (
            <div className={classNames(classes.root)}>
                <Grid container spacing={12}>
                    <Grid item xs={3}></Grid>
                    <Grid item xs={6}>
                        <div className={classNames(classes.paddingDiv)}>
                            <Card className={classNames(classes.cardDiv)}>
                                <AppBar position="static">
                                    <div className="p-16 pr-4 flex flex-row items-center justify-between">
                                        <Typography className="h1 pr-16" color="inherit">Forgot Password</Typography>
                                    </div>
                                </AppBar>
                                <div className={classNames(classes.instructionsDiv)}><p>Please enter your email address. If an account with that address exists, we will send and email with a link to reset your password.</p></div>
                                
                                <Formsy
                                    onValidSubmit={this.onSubmit}
                                >
                                <div className={classNames(classes.instructionsDiv)}>
                                    <TextFieldFormsy
                                        className={classNames(classes.textField)}
                                        type="email"
                                        name="email"
                                        label="Email"
                                        onChange={this.onChange}
                                        required
                                    />
                                </div>
                                <div className={classNames(classes.sendButton)}>
                                    <Button
                                        type="submit"
                                        variant="raised"
                                        color="primary"
                                        className="w-full mx-auto mt-16 normal-case"
                                        aria-label="LOG IN"
                                        value="legacy"
                                    >
                                        Send
                                </Button>
                                {this.sentNotice(this.state.emailSent, classNames(classes.sendNotice))}
                                </div>
                                </Formsy>
                            </Card>
                        </div>
                    </Grid>
                </Grid>

            </div>


        )
    }

    // Will only render after the email is sent, the prop is checking if this.state.emailSent is true
    sentNotice = (prop, divClass) => {
        return prop ?
            <div className={divClass}>
                <h2>If a user with that email exists, an email will be sent to the address.</h2>
            </div> : null
    }
}



function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        sendPasswordResetEmail: Actions.sendPasswordResetEmail,
        createPassToken: Actions.createPassToken,
        getUserByEmail: Actions.getUserByEmail
    }, dispatch);
}

function mapStateToProps({ auth }) {
    return {

    }
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(PasswordResetEmailRequest)));


// WEBPACK FOOTER //
// src/main/content/auth/PasswordResetEmailRequest.js